import { render, staticRenderFns } from "./SearchScore.vue?vue&type=template&id=cf5f29b4&scoped=true&"
import script from "./SearchScore.vue?vue&type=script&lang=js&"
export * from "./SearchScore.vue?vue&type=script&lang=js&"
import style0 from "./SearchScore.vue?vue&type=style&index=0&id=cf5f29b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5f29b4",
  null
  
)

export default component.exports